// extracted by mini-css-extract-plugin
module.exports = {"power-ocean-collection-B":"B_power-ocean-collection-B__Ad_pE"};